export enum IntegrationType {
  CRYPTO = "CRYPTO",
  CREDIT_CARD = "CREDIT_CARD",
}
